// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"a1917536","239":"395b9036","389":"f68060ac","732":"6ac2cb1d","857":"0d806c0b","885":"cb9f1e41","977":"037142e7"}[chunkId] + ".chunk.js";
};